import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useState } from 'react';
import LoadingIcon from '../share/LoadingIcon';
import { GET_NEWSlETTER_ENDPOINT } from '@/app/_libs/utils/constants/endpoints';
import { toast } from 'react-toastify';

export default function NewsLetter() {
  const [loadingFetchRequest, setLoadingFetchRequest] = useState();
  const [responseMessage, setResponseMessage] = useState('');
  const formSchema = Yup.object().shape({
    email: Yup.string().matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, {
      message: 'ایمیل نادرست می باشد',
    }),
  });
  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: yupResolver(formSchema),
  });

  const changeEmailHanlder = async (values) => {
    var formData = new FormData();
    formData.append('email', values.email);

    try {
      setLoadingFetchRequest(true); // Set loading state to true
      const res = await fetch(GET_NEWSlETTER_ENDPOINT, {
        method: 'post',
        body: formData,
        headers: new Headers({
          Accept: 'application/json',
        }),
      });
      const resJson = await res.json();
      if (resJson?.errors) {
        Object.keys(resJson.errors).forEach((key) =>
          toast.dark(resJson.errors[key][0])
        );
      } else {
        toast.dark('ایمیل شما با موفقیت ثبت شد');
      }
    } finally {
      setLoadingFetchRequest(false); // Reset loading state after the addToCart action completes
    }
  };
  return (
    <div>
      <form
        onSubmit={handleSubmit(changeEmailHanlder)}
        className="flex md:w-80 max-w-full justify-between border border-light-gray-300 rounded-md p-1"
      >
        <input
          className="border-none bg-none w-full md:w-[350px] max-w-full rounded-md text-sm bg-transparent"
          type="text"
          name="email"
          id="email"
          {...register('email')}
          placeholder="آدرس ایمیل خود را وارد کنید "
        />

        <button
          className="bg-gray-400 text-white font-bold px-4 rounded-md mr-1.5"
          type="submit"
        >
          {loadingFetchRequest ? <LoadingIcon /> : 'ثبت'}
        </button>
      </form>
      <span className="text-sm mt-2 block">{responseMessage}</span>
      <p className="inputValidation text-xs text-red-800">
        {errors['email']?.message}
      </p>
    </div>
  );
}
